module.exports = __webpack_public_path__ + "img/3_2.a8e85664.png";